import React from "react";
import "unum-landing-pages/src/assets/styles/main.scss";
import "./Root.module.scss";
import Theme from "@unum/theme";

type Props = {
  children: React.ReactNode;
};

const Root = ({ children }: Props) => {
  return <Theme>{children}</Theme>;
};

export default Root;
